import mobilePageGradients from './mobilePageGradients.js';

const defaultBackground = 'linear-gradient(180deg, #000 -9.87%, rgba(0, 0, 0, 0.00) 63.38%)';

const mobilePageGradient = {
  init() {
    const container = document.querySelector('.pages-container');
    if (!container) return;
    const pages = Array.from(container.querySelectorAll('.page'));
    for (const definition of mobilePageGradients) {
      const page = pages.find(element => element.dataset.id === String(definition.page));
      if (!page) continue;
      const target = page.querySelector('.filmstrip-stage') || page;
      target.classList.add('has-mobile-page-gradient');
      const overlay = target.querySelector('.mobile-page-gradient') || document.createElement('div');
      overlay.className = 'mobile-page-gradient';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.background = definition.background || defaultBackground;
      target.append(overlay);
    }
  },
};

export default mobilePageGradient;